// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"420abadf","513":"b5145c7a"}[chunkId] + ".chunk.css";
};